import React from "react";

const Modal = (props) => {
  return (
    <div
      class={`modal z-[1000]  ${
        props.display === true ? "" : "hidden"
      } bg-black opacity-1   fixed w-full h-full top-0 left-0 flex items-center justify-center`}
    >
      <div class="modal-overlay absolute w-full h-full bg-white opacity-95"></div>

      <div class="modal-container fixed w-full h-full z-50 overflow-y-hidden ">
        <div
          onClick={() => {
            props.setDisplay(false);
          }}
          class="modal-close cursor-pointer absolute top-5 right-0 cursor-pointer flex flex-col items-center mt-4 mr-4 text-black text-sm z-50"
        >
          <svg
            class="fill-current text-black"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 18 18"
          >
            <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path>
          </svg>
        </div>

        {/* <!-- Add margin if you want to see grey behind the modal--> */}
        <div class="modal-content container mx-auto h-auto text-left p-4">
          {/* <!--Title--> */}
          <div class="  lg:text-center text-center  ">
            <p class=" text-4xl  lg:text-4xl font-bold text-blue-700">
              S.S. PUBLIC SCHOOL
            </p>
            <p class="mt-6  lg:mt-10 text-2xl font-semibold"> Session 2023-24</p>
          </div>
          <div class="flex mt-10 ">
            <button class="  modal-close px-4 bg-red-900 p-3 rounded-lg text-white hover:bg-blue-900 text-3xl mr-2">
              ADMISSION
            </button>
            <button class="modal-close px-4 bg-red-900 p-3 rounded-lg text-white hover:bg-blue-900 text-3xl">
              OPEN
            </button>
          </div>
          {/* <!--Body--> */}
          <div class="lg:mt-9 mt-10">
            <div class="lg:flex justify-evenly">
              <div>
                <h1 class=" text-3xl lg:text-3xl text-red-400">
                  Why must learn with us ...
                </h1>
                <ul class=" mt-5 lg:mt-10 list-disc text-xl">
                  <li>Learn basic skill</li>
                  <li>Build a better life</li>
                  <li>Good staff</li>
                  <li>Best education</li>
                  <li>Supportive Atmosphere</li>
                </ul>
              </div>
              <div>
                <img
                  class=" mx-72 w-72 lg:w-80"
                  src="https://media.istockphoto.com/id/1206750602/vector/young-people-group-reading-books-study-learning-knowledge-and-education-vector-concept.jpg?s=612x612&w=0&k=20&c=8WotuURJr3LSN7vNs1ponstKZVtE_ySXzlyrp4B1kHw="
                  alt=""
                />
              </div>
            </div>

            <div class="lg:flex justify-evenly mt-10">
              <div>
                <img
                  class=" w-64 lg:w-72"
                  src="https://png.pngtree.com/png-clipart/20200508/ourmid/pngtree-hand-drawn-book-education-information-stationery-illustration-png-image_2200268.jpg"
                  alt=""
                />
              </div>
              <div class="">
                <h1 class=" mt-5   text-3xl lg:text-3xl text-red-400 lg:mt-12">
                  Admission open for :
                </h1>
                <ul class="lg:mt-10 list-disc text-xl">
                  <li>Learning</li>
                  <li>Development</li>
                  <li>Activities</li>
                </ul>
              </div>
            </div>
          </div>
          {/* <!--Footer--> */}
        </div>
      </div>
    </div>
  );
};

export default Modal;
